import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

import { Subscription } from 'rxjs';

@Component({
    selector: 'app-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnDestroy, OnInit {

    @Input() control: FormControl;
    @Input() loading: boolean;
    @Input() options: any;
    @Input() hasAllOption = true;
    @Input() context: 'filter' | 'other' = 'other';
    @Input() idLabelOptions = false;

    @Output() change = new EventEmitter();

    openDropdown: boolean;
    disabled: boolean;

    selectedIdLabelItem;

    private subscription: Subscription;

    constructor(private eRef: ElementRef) { }

    @HostListener('document:click', ['$event'])
    docClick(event: Event) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            // clicked outside this select - so we can close it
            this.openDropdown = false;
        }
    }

    ngOnInit() {
        if (!this.control || !(this.control instanceof FormControl)) {
            throw Error('SelectComponent requires FormControl using [control]');
        }

        if (this.idLabelOptions && this.options) {
            this.selectedIdLabelItem = this.options.find(opt => opt.id === this.control.value);
        }

        // check the form control's disabled state
        this.disabled = this.control.status === 'DISABLED';

        // and monitor it
        this.subscription = this.control.statusChanges.subscribe((status: any) => {
            this.disabled = status === 'DISABLED';

            // ensure dropdown is closed when disabled
            if (this.disabled) {
                this.openDropdown = false;
            }
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    toggleDropdown() {

        if (!this.disabled && !this.loading && this.options && this.options.length) {
            this.openDropdown = !this.openDropdown;
        }
    }

    select(value: any) {

        if (!this.disabled) {

            let newValue = value;

            if (this.idLabelOptions && value !== null) {
                newValue = value.id;
                this.selectedIdLabelItem = value;
            }

            const isChanging = this.control.value !== newValue;

            // set the value
            this.control.setValue(newValue);
            this.control.markAsTouched();
            this.control.markAsDirty();

            if (isChanging) {
                // emit change
                this.change.emit({
                    value: newValue
                });
            }
        }

        this.openDropdown = false;
    }

    onMousewheel(event: Event) {
        event.stopPropagation();
    }
}
